import api from './api'

export const getCardGroupByCustId = params => {
  return api.post(`/CloudParkAPI/Card/GetCardGroupByCustId`, params)
}
export const getCardGroupByCustDZId = params => {
  return api.post(`/CloudParkAPI/Card/GetCardGroupByCustDZId`, params)
}
export const getCardByQuery = params => {
  return api.post(`/CloudParkAPI/Card/GetCardByQuery`, params)
}
export const getCustomizedCardByQuery = params => {
  return api.post(`/CloudParkAPI/Card/GetCustomizedCardByQuery`, params)
}
export const getMonthCardListAsync = params => {
  return api.post(`/CloudParkAPI/Card/GetMonthCardListAsync`, params)
}
export const getCardConcentrateByQuery = params => {
  return api.post(`/CloudParkAPI/Card/GetCardConcentrateByQuery`, params)
}
export const getParkCust = params => {
  return api.post(`/CloudParkAPI/Card/GetParkCust`, params)
}
export const cardConcentrateDataTemplate = params => {
  return api.get(`/CloudParkAPI/Card/CardConcentrateDataTemplate`, params)
}
export const importCardConcentrateData = params => {
  return api.post(`/CloudParkAPI/Card/ImportCardConcentrateData`, params)
}
export const cardConcentrateDataUpload = params => {
  return api.post(`/CloudParkAPI/Card/CardConcentrateDataUpload`, params)
}
export const loadCardDDLSource = params => {
  return api.post(`/CloudParkAPI/Card/LoadCardDDLSource`, params)
}
export const loadCardOtherList = params => {
  return api.post(`/CloudParkAPI/Card/LoadCardOtherList`, params)
}
export const loadCustomizedCardOtherList = params => {
  return api.post(`/CloudParkAPI/Card/LoadCustomizedCardOtherList`, params)
}
export const loadCardConcentrateConcentrateEdit = params => {
  return api.post(`/CloudParkAPI/Card/LoadCardConcentrateConcentrateEdit`, params)
}
export const loadCardOtherListConcentrateAdd = params => {
  return api.post(`/CloudParkAPI/Card/LoadCardOtherListConcentrateAdd`, params)
}
export const getCardGroupByQuery = params => {
  return api.post(`/CloudParkAPI/Card/GetCardGroupByQuery`, params)
}
export const saveCardGroup = params => {
  return api.post(`/CloudParkAPI/Card/SaveCardGroup`, params)
}
export const deleteCardGroup = params => {
  return api.post(`/CloudParkAPI/Card/DeleteCardGroup`, params)
}
export const synCardGroupById = params => {
  return api.post(`/CloudParkAPI/Card/SynCardGroupById`, params)
}
export const saveCard = params => {
  return api.post(`/CloudParkAPI/Card/SaveCard`, params)
}
export const saveCardConcentrate = params => {
  return api.post(`/CloudParkAPI/Card/SaveCardConcentrate`, params)
}
export const deleteCard = params => {
  return api.post(`/CloudParkAPI/Card/DeleteCard`, params)
}
export const deleteCardCardConcentrate = params => {
  return api.post(`/CloudParkAPI/Card/DeleteCardCardConcentrate`, params)
}
export const synCardById = params => {
  return api.post(`/CloudParkAPI/Card/SynCardById`, params)
}
export const synCardConcentrateById = params => {
  return api.post(`/CloudParkAPI/Card/SynCardConcentrateById`, params)
}
export const setCardStatus = params => {
  return api.post(`/CloudParkAPI/Card/SetCardStatus`, params)
}
export const saveBlackPlate = params => {
  return api.post(`/CloudParkAPI/Card/SaveBlackPlate`, params)
}
export const getBlackPlateByQuery = params => {
  return api.post(`/CloudParkAPI/Card/GetBlackPlateByQuery`, params)
}
export const deleteBlackPlate = params => {
  return api.post(`/CloudParkAPI/Card/DeleteBlackPlate`, params)
}
export const synBlackPlateById = params => {
  return api.post(`/CloudParkAPI/Card/SynBlackPlateById`, params)
}
export const loadCardTypeList = () => {
  return api.get(`/CloudParkAPI/Card/LoadCardTypeList`)
}
export const loadCardConcentrateTypeList = () => {
  return api.get(`/CloudParkAPI/Card/LoadCardConcentrateTypeList`)
}
export const loadCarTypeList = () => {
  return api.get(`/CloudParkAPI/Card/LoadCarTypeList`)
}
export const LoadCardGroupTypeList = () => {
  return api.get(`/CloudParkAPI/Card/LoadCardGroupTypeList`)
}
export const getRechargeList = params => {
  return api.post(`/CloudParkAPI/Card/GetRechargeList`, params)
}
export const saveRecharge = params => {
  return api.post(`/CloudParkAPI/Card/SaveRecharge`, params)
}
export const cardConcentrateRecharge = params => {
  return api.post(`/CloudParkAPI/Card/CardConcentrateRecharge`, params)
}
export const cardConcentrateBatchRecharge = params => {
  return api.post(`/CloudParkAPI/Card/CardConcentrateBatchRecharge`, params)
}
export const synCardConcentrateRecharge = params => {
  return api.post(`/CloudParkAPI/Card/SynCardConcentrateRecharge`, params)
}
export const getCardConcentrateRechargeSync = params => {
  return api.post(`/CloudParkAPI/Card/GetCardConcentrateRechargeSync`, params)
}
export const synRecharge = params => {
  return api.post(`/CloudParkAPI/Card/SynRecharge`, params)
}
export const deleteRecharge = params => {
  return api.post(`/CloudParkAPI/Card/DeleteRecharge`, params)
}
export const getCardPayList = params => {
  return api.post(`/CloudParkAPI/Card/GetCardPayList`, params)
}
export const getCarPresnetList = params => {
  return api.post(`/CloudParkAPI/Card/GetCarPresnetList`, params)
}
export const cardUpload = params => {
  return api.post(`/CloudParkAPI/CardUpload/UploadCradData`, params)
}
export const importCardData = params => {
  return api.post(`/CloudParkAPI/CardUpload/ImportCardData`, params)
}
export const exportCardData = params => {
  return api.post(`/CloudParkAPI/CardExport/ExportCardData`, params)
}
export const exportCustomizedCardData = params => {
  return api.post(`/CloudParkAPI/CardExport/ExportCustomizedCardData`, params)
}
export const exportMonthCardData = params => {
  return api.post(`/CloudParkAPI/CardExport/ExportMonthCardData`, params)
}
export const exportCardConcentrateData = params => {
  return api.post(`/CloudParkAPI/CardExport/ExportCardConcentrateData`, params)
}
export const cardDataTemplate = () => {
  return api.get(`/CloudParkAPI/CardExport/CardDataTemplate`)
}
export const batchBindCard = params => {
  return api.post(`/CloudParkAPI/Card/BatchBindCard`, params)
}
export const getCardNo = params => {
  return api.post(`/CloudParkAPI/Card/GetCardNo`, params)
}
export const loadCardHisOtherList = params => {
  return api.post(`/CloudParkAPI/Card/LoadCardHisOtherList`, params)
}
export const getRechargeHisList = params => {
  return api.post(`/CloudParkAPI/Card/GetRechargeHisList`, params)
}
export const getCardHisByQuery = params => {
  return api.post(`/CloudParkAPI/Card/GetCardHisByQuery`, params)
}
export const getCardById = params => {
  return api.post(`/CloudParkAPI/Card/GetCardById`, params)
}
export const copyRecharge = params => {
  return api.post(`/CloudParkAPI/Card/CopyRecharge`, params)
}
export const getBaseCardInfo = params => {
  return api.post(`/CloudParkAPI/Card/GetBaseCardInfo`, params)
}
export const getCarGroupNewDefDays = params => {
  return api.post(`/CloudParkAPI/Card/GetCarGroupNewDefDays`, params)
}
export const getEhallCardListAsync = params => {
  return api.post(`/CloudParkAPI/Card/GetEhallCardListAsync`, params)
}
export const getReportingVehiclesListAsync = params => {
  return api.post(`/CloudParkAPI/Card/GetReportingVehiclesListAsync`, params)
}
export const getPlatCardGroupListAsync = params => {
  return api.post(`/CloudParkAPI/Card/GetPlatCardGroupListAsync`, params)
}
export const saveEhallCard = params => {
  return api.post(`/CloudParkAPI/Card/SaveEhallCard`, params)
}
export const saveReportingVehicles = params => {
  return api.post(`/CloudParkAPI/Card/SaveReportingVehicles`, params)
}
export const saveEhallCardSetChnl = params => {
  return api.post(`/CloudParkAPI/Card/SaveEhallCardSetChnl`, params)
}
export const saveReportingVehiclesSetChnl = params => {
  return api.post(`/CloudParkAPI/Card/SaveReportingVehiclesSetChnl`, params)
}
export const saveCustCardSetUser = params => {
  return api.post(`/CloudParkAPI/Card/SaveCustCardSetUser`, params)
}
export const savePlatCardGroup = params => {
  return api.post(`/CloudParkAPI/Card/SavePlatCardGroup`, params)
}
export const deleteEhallCard = params => {
  return api.post(`/CloudParkAPI/Card/DeleteEhallCard`, params)
}
export const deleteReportingVehicles = params => {
  return api.post(`/CloudParkAPI/Card/DeleteReportingVehicles`, params)
}
export const deleteCustCardSetUser = params => {
  return api.post(`/CloudParkAPI/Card/DeleteCustCardSetUser`, params)
}
export const deletePlatCardGroup = params => {
  return api.post(`/CloudParkAPI/Card/DeletePlatCardGroup`, params)
}
export const getGroupCust = params => {
  return api.post(`/CloudParkAPI/Card/GetGroupCust`, params)
}
export const getEhallCardGroupCust = params => {
  return api.post(`/CloudParkAPI/Card/GetEhallCardGroupCust`, params)
}
export const getReportingVehiclesGroupCust = params => {
  return api.post(`/CloudParkAPI/Card/GetReportingVehiclesGroupCust`, params)
}
export const getEhallCardDefaultSetChnlList = params => {
  return api.post(`/CloudParkAPI/Card/GetEhallCardDefaultSetChnlList`, params)
}
export const getReportingVehiclesDefaultSetChnlList = params => {
  return api.post(`/CloudParkAPI/Card/GetReportingVehiclesDefaultSetChnlList`, params)
}
export const ehallCardRecharge = params => {
  return api.post(`/CloudParkAPI/Card/EhallCardRecharge`, params)
}
export const ehallCardAddOrDedDuration = params => {
  return api.post(`/CloudParkAPI/Card/EhallCardAddOrDedDuration`, params)
}
export const getEhallCardFillDurationList = params => {
  return api.post(`/CloudParkAPI/Card/GetEhallCardFillDurationList`, params)
}
export const getEhallCardInOustList = params => {
  return api.post(`/CloudParkAPI/Card/GetEhallCardInOustList`, params)
}
export const getCustCardSetUserListAsync = params => {
  return api.post(`/CloudParkAPI/Card/GetCustCardSetUserListAsync`, params)
}



// WEBPACK FOOTER //
// ./src/api/card.js